// Generated by CoffeeScript 2.7.0
var SharePopover, copy;

import Popover from './popover.js';

({copy} = Skylark.Libs.Clipboard);

export default SharePopover = class SharePopover {
  constructor(element) {
    var share_link_input;
    this.element = element;
    if (!this.element.isPresent()) {
      return;
    }
    new Popover(this.element, {
      size: 'larger',
      type: 'prompt'
    });
    share_link_input = this.element.find('#js_share_link_input');
    this.element.node.proxy('click', '.js-copy-share-link', function() {
      if (copy(share_link_input)) {
        return Skylark.Bridge.newAlertify('已复制', {
          duration: 3000
        });
      }
      return Skylark.Bridge.newAlertify('复制失败，请手动复制', {
        type: 'danger',
        duration: 3000
      });
    });
    new Popover(this.element.find('.share-qrcode-popover'), {
      beforeOpenFunc: function(popover) {
        return popover._qrcode_rendered != null ? popover._qrcode_rendered : popover._qrcode_rendered = QRCode.toCanvas(popover.element.find('#js_share_qrcode').node, share_link_input.node.value, {
          color: {
            dark: '#313131ff'
          },
          margin: 0
        }, function() {});
      }
    });
  }

};
